const workercode = () => {
    let timerInterval;
    let time = 180;
    onmessage = function ({ data: { turn } }) {
      if (turn === "off" || timerInterval) {
        clearInterval(timerInterval);
        time = 180;
      }
      if (turn === "on") {
        timerInterval = setInterval(() => {
          time -= 1;
          postMessage({ time });
        }, 1000);
      }
    };
  };
  let code = workercode.toString();
  code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
  const blob = new Blob([code], { type: "application/javascript" });
  const worker_script = URL.createObjectURL(blob);
  
  export default worker_script;  